import { createContext, useContext } from "react";
import type { ConfiguratorStatePort } from "@/configurator/domain/ports/configuratorState";

const ConfiguratorStateContext = createContext<ConfiguratorStatePort | null>(
  null,
);

/**
 * Supplies the state adapter to every domain hook below it. Rendered only by
 * the composition roots, which are the only place allowed to name the concrete
 * store — see Architecture in AGENTS.md.
 */
export const ConfiguratorStateProvider = ConfiguratorStateContext.Provider;

/** The state port the composition root provided. */
export function useConfiguratorStateDomain(): ConfiguratorStatePort {
  const port = useContext(ConfiguratorStateContext);
  if (!port) {
    throw new Error(
      "Configurator domain hooks must be rendered inside ConfiguratorStateProvider.",
    );
  }
  return port;
}
